import { render, staticRenderFns } from "./message_tool_start_flow.vue?vue&type=template&id=12e248b6"
import script from "./message_tool_start_flow.vue?vue&type=script&lang=js"
export * from "./message_tool_start_flow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports